import { render, staticRenderFns } from "./PendingOrder.vue?vue&type=template&id=277ff821&scoped=true&"
import script from "./PendingOrder.vue?vue&type=script&lang=js&"
export * from "./PendingOrder.vue?vue&type=script&lang=js&"
import style0 from "./PendingOrder.vue?vue&type=style&index=0&id=277ff821&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277ff821",
  null
  
)

export default component.exports